import React, { useCallback, useMemo, useState } from "react"

import { makeStyles } from "@material-ui/core/styles"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import VisibilityOutlined from "@material-ui/icons/VisibilityOutlined"
import VisibilityOffOutlined from "@material-ui/icons/VisibilityOffOutlined"

import FormTextField, { FormTextFieldProps } from "./FormTextField"
import withValidateController from "./withValidateController"

const useStyles = makeStyles({
    field: {
        "& input": {
            borderRightWidth: "0px !important",
        },
        "& button:hover": {
            backgroundColor: "transparent",
        },
    },
})

export default function FormPasswordField({
    className,
    InputProps,
    ...rest
}: FormTextFieldProps) {
    const classes = useStyles()
    const [showPassword, setShowPassword] = useState(false)

    const onClickAdornment = useCallback(
        () => setShowPassword(!showPassword),
        [showPassword, setShowPassword],
    )

    const endAdornment = useMemo(() => {
        return (
            <InputAdornment position="end">
                <IconButton
                    aria-label="toggle password visibility"
                    onClick={onClickAdornment}
                >
                    {showPassword ? (
                        <VisibilityOutlined />
                    ) : (
                        <VisibilityOffOutlined />
                    )}
                </IconButton>
            </InputAdornment>
        )
    }, [onClickAdornment, showPassword])

    return (
        <FormTextField
            {...rest}
            className={
                className ? `${className} ${classes.field}` : classes.field
            }
            type={showPassword ? "text" : "password"}
            InputProps={{
                ...InputProps,
                endAdornment,
            }}
        />
    )
}

export const ValidatableFormPasswordField =
    withValidateController(FormPasswordField)
